export default "__VITE_ASSET__wGjl0lOS__"